<template>
  <div class="page">
    <PageHeader>
      Учет <i v-if="loading" class="el-icon-loading"></i>
    </PageHeader>
    <div class="content" v-if="loaded">
      <div v-if="exchange">
        <el-card
          shadow="always"
          :body-style="{ padding: '20px' }"
          v-loading="loading"
        >
          <div slot="header">
            <span> Полная история операции {{ $route.params.id }} </span>
          </div>
          <el-form label-width="135px">
            <el-form-item label="Открыта">
              <el-date-picker
                type="datetime"
                placeholder="Pick a date"
                v-model="exchange.dateStart"
                :readonly="true"
              ></el-date-picker>
            </el-form-item>
            <el-form-item v-if="exchange.dateEnd" label="Закрыта">
              <el-date-picker
                type="datetime"
                placeholder="Pick a date"
                v-model="exchange.dateEnd"
                :readonly="true"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Клиент">
              <div>{{ exchange.userName }}</div>
            </el-form-item>
            <el-form-item label="Тип">
              <div>
                {{ sourceTypeTitle }}
              </div>
            </el-form-item>
            <el-form-item label="Проект">
              <div>
                {{ sourceProjectTitle }}
              </div>
            </el-form-item>
            <el-form-item label="ID транзакции">
              <div>
                {{ exchange.transactionId || "N/A" }}
              </div>
            </el-form-item>
            <el-form-item label="Комментарий">
              <div>
                <el-input
                  type="textarea"
                  placeholder=""
                  :readonly="true"
                  v-model="exchange.comment"
                  maxlength="150"
                  show-word-limit
                >
                </el-input>
              </div>
            </el-form-item>
            <el-form-item v-if="exchange.isDeposit" label="Депозит?">
              <el-switch v-model="exchange.isDeposit" :disabled="true">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="exchange.isCorrection" label="Корректировка?">
              <el-switch v-model="exchange.isCorrection" :disabled="true">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="exchange.isOpex" label="Операционные расходы?">
              <el-switch v-model="exchange.isOpex" :disabled="true">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="exchange.isInternal" label="Движение средств?">
              <el-switch v-model="exchange.isInternal" :disabled="true">
              </el-switch>
            </el-form-item>
            <el-form-item v-if="exchange.isEmpty" label="Свободная форма?">
              <el-switch v-model="exchange.isEmpty" :disabled="true">
              </el-switch>
            </el-form-item>
          </el-form>
          <el-card
            v-for="transaction in exchange.ledgerTransactions"
            :key="transaction._id"
            shadow="hover"
          >
            <div slot="header">
              <span>Транзакция</span>
              <el-tooltip
                :content="`ID: ${transaction._id}`"
                placement="top"
                effect="light"
              >
                <span class="transaction-info"
                  ><i class="el-icon-info"></i>{{ transaction._id }}</span
                >
              </el-tooltip>
              <el-tooltip
                :content="
                  transaction.createdAt
                    ? `Транзакция создана ${transaction.creator &&
                        transaction.creator.login +
                          ' ' +
                          $dayjs(transaction.createdAt).format(
                            'DD.MM.YYYY HH:mm:ss'
                          )}`
                    : `Дата создания транзакции неизвестна`
                "
                placement="top"
                effect="light"
              >
                <span class="transaction-info"
                  ><i class="el-icon-plus"></i
                  >{{ transaction.creator && transaction.creator.login }}
                  {{
                    transaction.createdAt
                      ? $dayjs(transaction.createdAt).format(
                          "DD.MM.YYYY HH:mm:ss"
                        )
                      : "N/A"
                  }}</span
                ></el-tooltip
              >
              <el-tooltip
                v-if="
                  transaction.updatedAt &&
                    transaction.createdAt &&
                    !$dayjs(transaction.updatedAt).isSame(
                      $dayjs(transaction.createdAt)
                    )
                "
                :content="
                  transaction.updatedAt
                    ? `Транзакция изменена ${transaction.creator &&
                        transaction.creator.login +
                          ' ' +
                          $dayjs(transaction.updatedAt).format(
                            'DD.MM.YYYY HH:mm:ss'
                          )}, ${$dayjs(transaction.updatedAt).diff(
                        $dayjs(transaction.createdAt),
                        'minute'
                      )} минут после создания`
                    : `Дата изменения транзакции неизвестна`
                "
                placement="top"
                effect="light"
              >
                <span class="transaction-info"
                  ><i class="el-icon-edit"></i
                  >{{ transaction.creator && transaction.creator.login }}
                  {{
                    transaction.updatedAt
                      ? $dayjs(transaction.updatedAt).format(
                          "DD.MM.YYYY HH:mm:ss"
                        )
                      : "N/A"
                  }}</span
                ></el-tooltip
              >
            </div>
            <div>
              <div>
                {{
                  transaction.createdAt
                    ? $dayjs(transaction.createdAt).format(
                        "DD.MM.YYYY в HH:mm:ss"
                      )
                    : "В неизвестную дату"
                }}
                оператор
                {{ transaction.creator && transaction.creator.login }} создал
                эту транзакцию, в которой он оформил следующую информацию:
              </div>
              <div>
                {{
                  `${transaction.amount} ${(transaction.balanceAccount &&
                    transaction.balanceAccount.valute &&
                    transaction.balanceAccount.valute.name) ||
                    "N/A"}${
                    ["in", "deposit_in"].includes(transaction.direction)
                      ? " поступили на баланс "
                      : " ушли с баланса "
                  }${(transaction.balanceAccount &&
                    transaction.balanceAccount.title) ||
                    "N/A"}`
                }}
              </div>
              <div v-if="transaction.balanceAccountAfter">
                {{
                  `После этого баланс стал равен: ${transaction.balanceAccountAfter}`
                }}
              </div>
              <div v-if="transaction.isHidden && transaction.isRevert">
                Эта транзакция является реверсирующей для транзакции
                {{ transaction.reversedTransaction || "N/A" }}
              </div>
              <div v-if="transaction.isHidden && !transaction.isRevert">
                Эту транзакцию в последующем изменяли
              </div>
            </div>
          </el-card>
        </el-card>
        <el-collapse :accordion="false">
          <el-collapse-item :key="1" :title="'debug'" :name="1">
            <pre>
              {{ exchange }}
            </pre>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div v-else>
        Произошла ошибка при загрузке данных, пожалуйста попробуйте
        перезагрузить страницу
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getFullLedgerExchange, getSourceTypes, getProjects } from "@/api";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "LedgerFullExchange",
  data: () => ({
    loading: true,
    loaded: false,
    exchange: undefined,
    sourceTypes: undefined,
    sourceProjects: undefined
  }),
  computed: {
    sourceTypeTitle() {
      if (!this.sourceTypes && this.exchange.sourceType)
        return this.exchange.sourceType;
      if (!this.exchange.sourceType) return "N/A";
      const item = this.sourceTypes.find(
        i => i.sourceType === this.exchange.sourceType
      );
      return (item && item.title) || this.exchange.sourceType;
    },
    sourceProjectTitle() {
      if (!this.sourceProjects && this.exchange.sourceChannel)
        return this.exchange.sourceChannel;
      if (!this.exchange.sourceChannel) return "N/A";
      const item = this.sourceProjects.find(
        i => i.value === this.exchange.sourceChannel
      );
      return (item && item.name) || this.exchange.sourceChannel;
    }
  },
  methods: {
    async loadExchange() {
      const loadedExchange = await getFullLedgerExchange(this.$route.params.id);
      this.exchange = loadedExchange.data.result;
      console.log(this.exchange);
    },
    async getSourceTypes() {
      const { data } = await getSourceTypes();
      this.sourceTypes = data.result && data.result.docs;
    },
    async getSourceProjects() {
      const { data } = await getProjects();
      this.sourceProjects =
        data.result &&
        data.result.docs &&
        data.result.docs.filter(o => o.option === true);
    }
  },
  async mounted() {
    try {
      this.loading = true;
      await this.loadExchange();
      await this.getSourceTypes();
      await this.getSourceProjects();
    } catch (error) {
      console.log(error);
      this.handleResponseError(error);
    } finally {
      this.loading = false;
      this.loaded = true;
    }
  }
};
</script>
<style scoped>
.transaction-info {
  color: #aaa;
  margin-left: 1rem;
  font-size: 0.85rem;
}
.transaction-info i {
  margin-right: 5px;
  color: hsl(210, 50%, 63%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/full.vue